import { ContentType } from '../domain/types';

export const contentTypeLabels: { [key in ContentType]: string } = {
  [ContentType.VIDEO]: 'video',
  [ContentType.VIRTUAL_TOUR]: 'virtual tour',
  [ContentType.PANORAMICA]: 'panoramica',
  [ContentType.PLANIMETRIA]: 'planimetria',
  [ContentType.FOTO]: 'foto',
};
